import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section aria-labelledby="guarantee-title" className="w-full bg-cream px-4 py-8" data-id="element-110" data-mp="1o3x3nprb6w3l">
      <div className="mx-auto max-w-2xl rounded-2xl border-2 border-cta bg-white p-4 text-center" data-id="element-111" data-mp="223eltma3nb3z">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-cta/15 px-2.5 py-0.5 font-head text-[10px] font-bold uppercase tracking-wide text-cta-dark" data-id="element-112" data-mp="1x4bs2xzkkrbb">
          <ShieldCheckIcon className="h-3 w-3" aria-hidden="true" data-id="element-113" data-mp="19f0o77mxagsy" />
          Zero Risk
        </span>
        <h2 id="guarantee-title" className="mt-1 font-head text-2xl font-bold uppercase leading-none text-night sm:text-4xl" data-id="element-114" data-mp="14hh8e3aktvyw">
          7-Day money-back guarantee
        </h2>
        <p className="mt-1.5 text-[12px] font-semibold leading-snug text-night sm:text-sm" data-id="element-115" data-mp="1ed26hqciyc3d">
          Open the complete system. Explore all six modules. Discover the lesson plans, grammar
          resources, vocabulary, speaking activities, teaching tools, progression systems and
          bonuses.
        </p>
        <p className="mt-1.5 text-[12px] leading-snug text-night/65" data-id="element-116" data-mp="oz02xtw5fyns">
          Try SPANISH TEACHER PRO™ for seven full days. If the system isn’t right for you, contact us
          during the guarantee period and request your refund according to the applicable terms.
        </p>
        <p className="mt-1.5 font-head text-[10px] font-bold uppercase tracking-widest text-cta-dark" data-id="element-117" data-mp="12pv8oxbcpzn5">
          Your purchase is protected
        </p>
      </div>
    </section>;
}